import { Component, OnInit, ViewChild, EventEmitter } from '@angular/core';
import { AdminSidePatientsComponent } from '../admin-side-patients/admin-side-patients.component';
import { Router, ActivatedRoute } from '@angular/router';
import {MatDialogRef, MAT_DIALOG_DATA, MatDialog} from '@angular/material/dialog';
import { PCCService } from 'src/app/services/pcc.service';
import { AuthService } from 'src/app/services/auth.service';
import * as global from '../../../includes/global'
import { CompanyService } from 'src/app/services/Modules/company.service';
@Component({
  selector: 'app-admin-patients',
  templateUrl: './admin-patients.component.html',
  styleUrls: ['./admin-patients.component.css']
})
export class AdminPatientsComponent implements OnInit {
  adminSidePatientsComponent: AdminSidePatientsComponent;
  activatedRoute:'list'|'pcc-list' | 'matrix-list' | 'advance-search-list' | any = "list";
  currentUser;
  isLoggedInToPCC:boolean = false;
  global = global;
  matrix = false;
  isNurseUser: boolean = false;
  patientSearchAcrossCompany = false;
  listRoute: any = '';
  advanceRoute: any = '';
  company_id: string = '';
  constructor(
    private dialog: MatDialog,
    private _router:Router,
    private _route:ActivatedRoute,
    private _authService:AuthService,
    public pccService:PCCService,
    private _companyService: CompanyService
  ) {
    this.currentUser = this._authService.currentUser;
    if (window.location.pathname.includes('company')) {
      this.company_id = this._route.parent.snapshot.params.id;
    } else {
      this.company_id = this.currentUser.company_id;
    }
    if (this.currentUser.user_type.toLowerCase() === 'nurse') {
      this.isNurseUser = true;
    }
  }

  async ngOnInit() {
    this.listRoute = `/company/${this.company_id}/patients/list`
    this.advanceRoute = `/company/${this.company_id}/patients/advance-search-list`
    this.patientSearchAcrossCompany = await this._companyService.checkCompanyPermission("patient_search_accross_company", this.currentUser.company_id);
    this.activatedRoute = this._route.snapshot.firstChild.url[0].path;
    
    this.isLoggedInToPCC = !!this.pccService.pccUserinfo;
    this.pccService.pccUserinfo$.subscribe(value => {
      this.isLoggedInToPCC = !!value
    })
  }
  onOutletLoaded = (component) => {
    if(component instanceof AdminSidePatientsComponent) {
      this.matrix = false;
    }
  }
  changeRoute() {
    this._router.navigateByUrl(`/patients/${this.activatedRoute}`)
  }
  onAddNewClick() {
    this._router.navigate(['patient-add'], {skipLocationChange: true});
  }
  onEditClick($event) {
    const onSuccess = new EventEmitter();
    onSuccess.subscribe(() => {
      this._router.navigate(['/patient-add'])
    })
  }
  onDetailClick($event) {
    this._router.navigate([`patient-detail/${$event}`]);
  }
  isRoundingSheetButtonVisible() {
    return this.currentUser.user_type == '1' && this.currentUser.has_pcc_account == 'true'

  }
}
